<template>
	<div class="shared-progress-bar">
		<div class="shared-progress-bar__circle shared-progress-bar__circle--start"/>
		<div
			v-tooltip="{ content: tooltip }"
			class="shared-progress-bar__circle shared-progress-bar__circle--track"
			:style="{ marginLeft : value > 100 ? `100%` : `${value}%` }"/>
		<div class="shared-progress-bar__circle shared-progress-bar__circle--end"/>
		<div
			class="shared-progress-bar__track"
			:style="{ width : `${value}%` }"/>
		<div
			class="shared-progress-bar__path"
			:style="{
				background:
					gradientValue ? `linear-gradient(
					to right,
					var(--grey-light) ${gradientValue}%,
					transparent ${gradientValue}% calc(${ gradientValue }% + 0.25rem),
					rgba(var(--rgb-warning), 0.4) calc(${ gradientValue }% + 0.25rem) calc(100% - 0.5rem),
					transparent calc(100% - 0.75rem)` : undefined,
			}"/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedProgressBarEmits, SharedProgressBarProps } from './SharedProgressBarSetup';
import SharedProgressBarSetup from './SharedProgressBarSetup';
const emits = defineEmits<SharedProgressBarEmits>() as SharedProgressBarEmits;
const props = withDefaults(defineProps<SharedProgressBarProps>(), SharedProgressBarSetup.defaultProps);
const setup = new SharedProgressBarSetup(props, emits);
// #endregion
</script>

<style lang="less">
@import "@/styles/variables";
@import "@/styles/mixins";

.shared-progress-bar {
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	height: 2rem;

	&__circle {
		position: absolute;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;

		&--start {
			left: 0;
			transform: translateX(-50%);
			background-color: var(--info);
		}

		&--track {
			z-index: 3;
			transform: translateX(-50%);
			width: 1rem;
			height: 1rem;
			border: 3px solid var(--info);
			background: white;
			box-shadow:
				0 0.125rem 0.125rem rgb(0 0 0 / 3%),
				0 0.25rem 0.25rem rgb(0 0 0 / 3%),
				0 0.5rem 0.5rem rgb(0 0 0 / 3%),
				0 1rem 1rem rgb(0 0 0 / 3%),
				0 2rem 2rem rgb(0 0 0 / 3%);
		}

		&--end {
			right: 0;
			transform: translateX(50%);
			background-color: var(--grey-light);
		}
	}

	&__path {
		position: absolute;
		z-index: 0;
		width: 100%;
		height: 0.125rem;
	}

	&__track {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		height: 0.125rem;
		background-color: var(--info);

		&::before {
			content: "";
			position: absolute;
			z-index: 3;
			right: 0;
			left: 0;
			width: 100%;
			height: 2rem;
			border-radius: 2px;
			background: rgba(var(--rgb-info), 0.1);
		}
	}
}

/* .shared-progress-bar {
	position: relative;
	align-items: center;
	display: flex;
	width: 100%;

	&__path {
		background-color: var(--grey-light);
		width: 100%;
		&-start, &-end {
			position: absolute;
			background-color: var(--grey-light);
		}

		&-start {
			left: 0;
		}

		&-end {
			right: 0;
		}
	}

	&__value {
		transition: width 0.6s;
		will-change: width;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		max-width: 100%;
		height: 100%;

		each(@colors, {
			@color: ~"--@{value}";
      .shared-progress-bar--@{value} & {
        background: var(@color);
      }
    });
	}
} */
</style>
